import Box from "@mui/material/Box";
import {useState} from "react";
import {Grid} from "@mui/material";
import {UserBasicCard} from "./user-basic-card";
import {UserFullInfo} from "./user-full-info";

export const ListUsers = ({ users, reload }) => {
    const [showFullDialog, setShowFullDialog] = useState(false);
    const [selectedUser, setSelectedUser] = useState(undefined);

    const view = (user) => {
        setSelectedUser(user);
        setShowFullDialog(true)
    }

        return (
            <div>

                {
                    users.length > 0 ?
                        <Box sx={{flexGrow: 1, textAlign: 'center'}} marginLeft={{ xs: '2.2rem', md: 'auto'}}>
                            <Grid container spacing={2}>
                                {
                                    users
                                        .map((user) => <Grid key={user.username} item xs={8} md={4} sm={6} lg={3}>
                                            <UserBasicCard user={user} viewUser={view}/>
                                        </Grid>)
                                }
                            </Grid>
                        </Box>
                        :
                        null
                }

                {
                    selectedUser ?
                        <UserFullInfo user={selectedUser} open={showFullDialog} setOpen={setShowFullDialog} reload={reload} />
                        : null
                }

            </div>
        )
}
